import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RadialIndicator from '../../../../shared/components/RadialIndicator/RadialIndicator'

export class BeverageProgramGradeContainer extends Component {

    getFillPercentForLetterGrade(letterGrade) {
        const grade = letterGrade[0];
        const modifier = letterGrade[1];

        let fillPercent;
        switch (grade) {
            case "A":
                fillPercent = 90;
                break;
            case "B":
                fillPercent = 70;
                break;
            case "C":
                fillPercent = 50;
                break;
            case "D":
                fillPercent = 30;
                break;
        }

        if (modifier) {
            switch (modifier) {
                case "+":
                    fillPercent += 8;
                    break;
                case "-":
                    fillPercent -= 8;
                    break;
            }
        }

        return fillPercent;

    }

    render() {
        const props = this.props;

        const fillPercent = this.getFillPercentForLetterGrade(props.letterGrade);

        return (
            <div className="row">
                <div className="col-xs-12 col-sm-1"></div>
                <div className="radial-indicator-wrapper program-grade col-xs-12 col-sm-4 ">
                    <RadialIndicator
                        outerFill={'transparent'}
                        innerWidthFunctionOfWidth={(width)=>(width*5.1/6)}
                        containerId={'report-grade-radial-indicator-autofit-container'}
                        fillPercentsAndColors={ [{fillPercent: fillPercent, color: "white"}] }
                        fillerText={ props.letterGrade }
                        outerCircleClasses={ 'radial-indicator-outer' }
                        innerCircleClasses={ 'radial-indicator-inner' }
                        pathClasses={ "" }
                        textClasses={ 'radial-indicator-text light-text' }
                    />
                </div>
                <div className="col-xs-12 col-sm-6">
                    <h2>Your Bar Profit Analysis grade is &ldquo;{ props.letterGrade}&rdquo;</h2>
                    <p className="intro">Your grade is based on a comparison of data from bars and restaurants across the U.S.</p>
                </div>
            </div>
        );
    }
}

BeverageProgramGradeContainer.propTypes = {
    letterGrade: PropTypes.string.isRequired,
};

export default BeverageProgramGradeContainer;